import { render, staticRenderFns } from "./discountCartAmount.vue?vue&type=template&id=3248e90f&scoped=true&"
import script from "./discountCartAmount.vue?vue&type=script&lang=js&"
export * from "./discountCartAmount.vue?vue&type=script&lang=js&"
import style0 from "./discountCartAmount.vue?vue&type=style&index=0&id=3248e90f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3248e90f",
  null
  
)

export default component.exports